import { Timer } from "./timer.js";
export default function (callback, delay, time) {
  var t = new Timer();
  delay = delay == null ? 0 : +delay;
  t.restart(function (elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-timer@1.0.10@d3-timer/src/timeout.js
// module id = 140
// module chunks = 0